module.exports = __webpack_public_path__ + "media/images/png/rent/4-d3b50ac9761441c56a7078f31ead4601.png";